import { render } from "./LfaNav.vue?vue&type=template&id=544db9d8&scoped=true"
import script from "./LfaNav.vue?vue&type=script&lang=js"
export * from "./LfaNav.vue?vue&type=script&lang=js"

import "./LfaNav.vue?vue&type=style&index=0&id=544db9d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544db9d8"]])

export default __exports__